import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SedsFlatButtonComponent } from './seds-flat-button.component';
import { SedsCoreButtonModule } from '../../seds-buttons/seds-core-button/seds-core-button.module';

@NgModule({
  declarations: [SedsFlatButtonComponent],
  imports: [CommonModule, SedsCoreButtonModule],
  exports: [SedsFlatButtonComponent],
})
export class SedsFlatButtonModule {}
